/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Modal, Button } from 'react-bootstrap';
import { FaAngleRight, FaHome, FaSearch } from 'react-icons/fa';

import { GET_URL_LOGO_PADRAO, GET_LIST_LOJA, GET_LIST_REDELOJACANAL } from 'services/Solicitacao';
import { UPLOAD_LOGO } from 'services/Solicitacao';
import RequestMaterialsActions from 'store/modules/request-materials/actions';
import TitlePages from 'components/_base/TitlePages';
import InputFileCustom from 'components/_base/InputFile';

import { tabs, passos } from '../_constants';
import './styles.scss';

const Cliente = (props) => {
  let { setLoader, updateRascunho, model, renderErrors, setActiveTab } = props;
  let errors = (model.errors || []).filter((error) => error.passo === passos.passoCliente.nro);

  model.loja = model.loja || {};

  const dispatch = useDispatch();

  const [cliente, setCliente] = useState(model.loja || {});
  //const [clientSelected, setClientSelected] = useState(null);
  //const [clientsList, setClientsList] = useState([]);
  const [redeSelected, setRedeSelected] = useState(null);
  const [redeList, setRedeList] = useState([]);
  const [logoPadrao, setLogoPadrao] = useState('');
  const [search, setSearch] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [withBrand, setWithBrand] = useState(true);

  //===========================================================================================================================
  useEffect(() => {
    setCliente(model.loja || {});
  }, [model]);

  //-----------------------------------------------------------------------------------------------
  useEffect(() => {
    (async () => {
      setLoader(true);
      const resultLogoPadrao = await GET_URL_LOGO_PADRAO();

      if (resultLogoPadrao.value) setLogoPadrao(resultLogoPadrao.value);

      setLoader(false);
    })();
  }, [false]);

  //===========================================================================================================================
  const updateCliente = (loja) => {
    model.loja = loja;
    model.lojaId = loja.lojaId || 0;
    setCliente(loja);
  };

  //-----------------------------------------------------------------------------------------------
  const searchByCodeCNPJ = (event) => {
    setSearch(event.target.value);
  };

  //-----------------------------------------------------------------------------------------------
  const searchByName = (event) => {
    setSearch(event.target.value);
  };

  //-----------------------------------------------------------------------------------------------
  const onSearch = async () => {
    setLoader(true);
    //const data = await GET_LIST_LOJA({ codigoCnpjRazaoSocial: search });
    const data = await GET_LIST_REDELOJACANAL({ filtroNomeRede: search });
    if (data.value.length === 1) {
      updateCliente(data.value[0].loja);
    } else {
      setRedeList(data.value);
      setShowModal(true);
    }

    setLoader(false);
  };

  //-----------------------------------------------------------------------------------------------
  const selectRede = (index) => {
    setRedeSelected(index);
    updateCliente(redeList[index].loja);

    const action = RequestMaterialsActions.setCustomer(redeList[index]);
    dispatch(action);

    setWithBrand(true);
  };

  //-----------------------------------------------------------------------------------------------
  const hideModal = () => {
    setShowModal(false);
  };

  //-----------------------------------------------------------------------------------------------
  const setSettingsBrand = (event) => {
    setWithBrand(event.target.value === 'true');
  };

  //-----------------------------------------------------------------------------------------------
  const uploadLogo = async (event) => {
    event.preventDefault();

    setLoader(true);
    const formData = new FormData();

    formData.append('lojaId', cliente.lojaId);
    formData.append('file', event.target.files[0]);

    const data = await UPLOAD_LOGO(formData);

    updateCliente({ ...cliente, urlLogo: data.value });

    setLoader(false);
  };

  //===========================================================================================================================
  return (
    <>
      <TitlePages title="Escolha a Rede" />
      <hr style={{ width: '100%' }} />
      <div className="wrapper-content-pedido-cliente">
        <div className="content-pedido-cliente">
          {renderErrors(errors)}

          {/* Busca =========================================================================================================== */}
          <div className="content-cliente-search">
            <div id="busca" className=" busca">
              {/* Rede ------------------------------------------------------------------------------ */}
              <div className="col-md-8">
                <label htmlFor="">Rede do Cliente</label>
                <div className="input-with-icon">
                  <input type="text" onChange={searchByCodeCNPJ} />
                  <div className="icon" onClick={onSearch}>
                    <FaSearch size={22} />
                  </div>
                </div>
              </div>

              {/* Codigo/CNPJ ----------------------------------------------------------------------- */}
              {/* <div className="col-md-5">
              <label htmlFor="">Código ou CNPJ do Cliente</label>
              <div className="input-with-icon">
                <input type="text" onChange={searchByCodeCNPJ} />
                <div className="icon" onClick={onSearch}>
                  <FaSearch size={22} />
                </div>
              </div>
            </div> */}

              {/* Ou -------------------------------------------------------------------------------- */}
              {/* <div className="col-lg-2 align-self-center text-center">
              <label className="m-0">OU</label>
            </div> */}

              {/* Razao Social ---------------------------------------------------------------------- */}
              {/* <div className="col-md-5">
              <label htmlFor="">Razão Social</label>
              <div className="input-with-icon">
                <input type="text" onChange={searchByName} />
                <div className="icon" onClick={onSearch}>
                  <FaSearch size={22} />
                </div>
              </div>
            </div> */}
            </div>
          </div>

          {/* Modal Busca Loja/Rede =========================================================================================== */}
          <Modal show={showModal} onHide={hideModal} className="modal-busca-loja">
            <Modal.Header closeButton className="header">
              <Modal.Title>Redes</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <table className="table table-striped">
                <thead>
                  <tr>
                    <th>Id</th>
                    <th>Rede</th>
                    <th>Canal</th>
                  </tr>
                </thead>
                <tbody>
                  {redeList.map((item, index) => {
                    return (
                      <tr
                        className={
                          redeSelected === index
                            ? 'tr-selecao-loja tr-selecionado'
                            : 'tr-selecao-loja'
                        }
                        key={index}
                        onClick={() => selectRede(index)}
                        style={{
                          backgroundColor:
                            redeSelected === index ? 'rgba(40, 109, 184,.5)' : 'inherit',
                        }}
                      >
                        <td>{item.redeId}</td>
                        <td>{item.rede}</td>
                        <td>{item.canal}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </Modal.Body>
            <Modal.Footer className="modal-footer">
              <Button variant="primary" onClick={hideModal} className="button-close">
                CONCLUIR
              </Button>
            </Modal.Footer>
          </Modal>
          {/* Fim Modal Busca Loja ============================================================================================ */}

          {/* Dados Cliente =================================================================================================== */}
          <div className="display-client">
            <div>
              {/* Rede ------------------------------------------------------------------------------ */}
              <div>
                <label htmlFor="">Rede: </label>
                <span>{cliente.rede?.nome ? cliente.rede?.nome : ''}</span>
              </div>
              {/* Canal ----------------------------------------------------------------------------- */}
              <div>
                <label htmlFor="">Canal: </label>
                <span>{cliente.canal?.nome ? cliente.canal?.nome : ''}</span>
              </div>
            </div>

            {/* Logo -------------------------------------------------------------------------------- */}
            <div className="set-settings-brand">
              <div style={{ opacity: cliente.lojaId ? 1 : 0 }} className="text-right">
                <input
                  type="radio"
                  id="set-brand"
                  name="with-brand"
                  onChange={setSettingsBrand}
                  value={true}
                  checked={withBrand}
                />
                <label htmlFor="set-brand">Com Logo</label>

                <input
                  type="radio"
                  id="set-no-brand"
                  name="with-brand"
                  onChange={setSettingsBrand}
                  value={false}
                  checked={!withBrand}
                />
                <label htmlFor="set-no-brand">Sem Logo</label>

                {withBrand ? (
                  <div>
                    {cliente.urlLogo && (
                      <img
                        className="img-logo"
                        src={cliente.urlLogo ? cliente.urlLogo : ''}
                        alt=""
                      />
                    )}
                    <div style={{ marginTop: '20px' }}></div>
                    <InputFileCustom name="Logo" onChange={uploadLogo}></InputFileCustom>
                  </div>
                ) : (
                  <div>
                    <div className="msg-logo-padrao text-center">
                      Seus materiais serão impressos com o logo padrão.
                    </div>
                    <img className="img-logo" src={logoPadrao} alt="" />
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="row">
            {/* Botao Pagina Inicial ---------------------------------------------------------------- */}
            <div className=" text-left">
              <Link to="/">
                <button className="btn btn-primary btn-navigation">
                  <span>
                    <FaHome size={26} />
                  </span>
                  <span>PÁGINA INICIAL</span>
                </button>
              </Link>
            </div>

            {/* Botao Avancar ----------------------------------------------------------------------- */}
            <div className=" d-flex flex-row-reverse">
              <button
                className={`btn btn-primary btn-navigation btn-navigation-right ${
                  cliente.lojaId > 0 ? '' : 'btn-disabled'
                }`}
                onClick={() => {
                  if (cliente.lojaId > 0) {
                    updateRascunho();

                    if (model.pedidoDeCampanha) setActiveTab(tabs.tabLayoutCampanha);
                    else setActiveTab(tabs.tabMateriais);
                  }
                }}
              >
                <span>AVANÇAR</span>
                <span>
                  <FaAngleRight size={26} />
                </span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Cliente;
